import HttpClient from "libs/utils/HttpClient";

class ExternalService {
  async checkCompany(juristicID) {
    try {
      const response = await HttpClient.get(
        `/api/external/isc/company?juristicID=${juristicID}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new ExternalService();
